import { motion } from "framer-motion";
import { MdCheck } from "react-icons/md";

interface StepElementProps {
  number: number;
  text: string;
  currentStage: number;
}

const StepElement: React.FC<StepElementProps> = ({
  number,
  text,
  currentStage,
}) => {
  return (
    <div className="flex-col justify-center items-center gap-1 inline-flex">
      <div
        className={`size-8 rounded-full ${
          // Apply thicker border when selected and after that
          currentStage >= number ? "border-2" : "border border-dashed"
        } ${
          // Fill when passing to the next stage
          currentStage > number ? "bg-neutral-600" : "bg-transparent"
        } border-neutral-600 flex-col justify-center items-center gap-2 flex relative`}
      >
        {
          // Show the number just before and at the same stage
          currentStage <= number ? (
            <div
              className={`text-neutral-600 text-[10px] ${
                currentStage === number ? "font-bold" : "font-normal"
              } font-sans uppercase leading-3 tracking-wide select-none`}
            >
              {number}
            </div>
          ) : (
            // Otherwise show a check sign
            <motion.div
              initial={{scale: 0}}
              animate={{ scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ type: "spring", duration: 0.7, bounce: 0.5 }}
              className="w-3 h-3 relative"
            >
              <MdCheck className="w-full h-full fill-white" />
            </motion.div>
          )
        }
      </div>
      <div
        className={`text-center text-neutral-600 text-[10px] ${
          currentStage === number ? "font-bold" : "font-normal"
        } font-sans uppercase leading-3 tracking-wide select-none whitespace-nowrap`}
      >
        {text}
      </div>
    </div>
  );
};

export default StepElement;
